<div id="academy-course" class="page-layout simple left-sidebar inner-scroll">

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT -->
        <div id="course-content" class="content">

            <!-- ------contenido------ -->
            <div class="page-layout carded fullwidth inner-scroll cursoStep">
                <!-- TOP BACKGROUND -->
                <div class="top-bg"></div>
                <!-- CENTER -->
                <div class="center">
                    <!-- CONTENT HEADER -->
                    <div class="header p-24" fxLayout="row" fxLayoutAlign="start center">
                        <!--{{'FILEMANAGER.TITULO' | translate}}-->
                        <h2 class="m-0">{{'WIZARD.TITULO' | translate}}</h2>
                    </div>
                    <!-- CONTENT CARD -->
                    <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                        <!-- CONTENT TOOLBAR -->
                        <div class="toolbar primary px-24 py-8">
                            <!--<span>{{'FILEMANAGER.SUBTI' | translate}}</span>-->
                            <!--<span>{{'WIZARD.DESCRIPCION' | translate}}</span>-->
                            <span>{{'FILEMANAGER.CT_NAME'  | translate}}</span>
                        </div>
                        <!-- CONTENT -->
                        <div class="content" fusePerfectScrollbar>

                            <div class="course-step-content p-20">
                                <ng-container *ngIf="cargando">
                                    <div fxLayout="column" fxLayoutAlign="space-between center">
                                        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                                        <h1>{{'WIZARD.CT_INFORMACION.LISTA.CARGANDO' | translate}}</h1>
                                    </div>

                                </ng-container>
                                <ng-container *ngIf="estadoCT && !cargando" [@animate]="{value:'*',params:{delay:'200ms', y:'125px'}}">
                                    <div class="statusDiv" fxLayout="row" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                        <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                                            <h2>{{'WIZARD.CT_INFORMACION.LISTA.NODATA' | translate}}</h2>
                                            <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="!listadoGPTW && !estadoCT">

                                    <div *ngIf="!guardandoArchivo && carpetaActual != ''" class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event)" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                        <input hidden type="file" #fileInput (change)="onFileChange($event)">
                                        <h1>{{'FILEMANAGER.CARGA.TITULO' | translate}}</h1>
                                    </div>
                                    <!--- guardando registros en back --->
                                    <div *ngIf="guardandoArchivo" class="mt-20" fxLayout="row" fxLayoutAlign="space-around stretch">
                                        <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                            <h2 class="mt-0">{{'FILEMANAGER.CARGA.CARGANDOTIT' | translate}}</h2>
                                            <mat-divider></mat-divider>
                                            <div class="mt-20 mb-20">
                                                <div class="h4 secondary-text">{{'FILEMANAGER.CARGA.CARGANTOTXT' | translate}}</div>
                                                <mat-progress-bar mode="indeterminate" class="mt-20"></mat-progress-bar>
                                            </div>
                                        </div>
                                    </div>

                                    <div fxLayout="column" fxLayoutAlign="space-around stretch">
                                        <mat-form-field *ngIf="leveuser == '1' && !cargando">
                                            <mat-label>{{'FILEMANAGER.LABEL01' | translate}}</mat-label>
                                            <mat-select>
                                                <mat-option *ngFor="let ct of centrosTrabajoArray" value="No aplica" (click)="filtroCT(ct.centro.id_CT);">
                                                    {{ct.centro.nombre_CT}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-list *ngIf="mostrar">
                                            <mat-list-item>
                                                <button mat-icon-button aria-label="" (click)="openDialog()">
                                                <mat-icon matTooltip="{{ 'WIZARD.DATOSDOCTORES.ACCIONES.LABEL01' | translate}}" style="font-size: 60px; color: #188FBF;">person_add</mat-icon>
                                                </button>
                                                <p mat-line>{{ 'WIZARD.DATOSDOCTORES.ACCIONES.LABEL02' | translate}}</p>
                                            </mat-list-item>
                                        </mat-list>
                                    </div>
                                    <ng-container *ngIf="mostrar">
                                        <button mat-flat-button color="primary" *ngIf="statustype" (click)="changeTable()">Mostrar doctores</button>
                                        <button mat-flat-button color="primary" *ngIf="!statustype" (click)="changeTable()">Mostrar Colaboradores</button>
                                    </ng-container>




                                    <div fxLayout="column" fxLayoutAlign="space-around stretch" *ngIf="!tmp">
                                        <mat-form-field>
                                            <mat-label>{{'FILEMANAGER.LABEL01' | translate}}</mat-label>
                                            <mat-select>
                                                <mat-option *ngFor="let ct of centrosTrabajoArray" value="No aplica" (click)="filtroCT(ct.centro.id_CT);">
                                                    {{ct.centro.nombre_CT}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <ng-container *ngIf="!cargando && !statustype" style="margin-top: 10px;">
                                        <tabla-medico [actualizaMedicolist]="eventsSubjectStatusMedicos.asObservable()"></tabla-medico>
                                    </ng-container>
                                    <ng-container *ngIf="!cargando && statustype">
                                        <tablacolaboradores [listaArchivosEmpresa]="listaArchivosEmpresa" [puedeBorrar]=true [actualizaArchivos]="eventsSubject.asObservable()" [actualizaFileslist]="eventsSubjectStatusArchivos.asObservable()" (carpetaAbierta)="setNombreCarpeta($event)"></tablacolaboradores>
                                    </ng-container>

                                    <ng-container *ngIf="!cargando && NoshowTable">

                                        <br>
                                        <div class="roundEdg primary mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 5%; margin-bottom: 3%;">
                                            <h2>{{'WIZARD.DatosColaboradores.NOFOUNDDATA' | translate}}</h2>
                                            <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                                        </div>
                                    </ng-container>
                                </ng-container>


                                <ng-container *ngIf="listadoGPTW && listaArchivosInstituto && !cargando">
                                    <div class="statusDiv pb-40" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                        <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                                            <h2>{{'FILEMANAGER.GPTW.TITULO' | translate}}</h2>
                                            <mat-icon class="ml-20 s-40">check_circle</mat-icon>
                                        </div>
                                    </div>

                                    <mat-accordion [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                        <ng-container *ngFor="let empresa of listaArchivosInstituto.empresas; index as i">
                                            <mat-expansion-panel class="mb-20">

                                                <mat-expansion-panel-header class="accent-50">
                                                    <mat-panel-title>
                                                        <b>{{empresa.nombreEmpresa}}</b>
                                                    </mat-panel-title>
                                                    <mat-panel-description>
                                                        {{'FILEMANAGER.GPTW.NUMFILES' | translate}}<b>{{empresa.archivos.length}}</b>
                                                    </mat-panel-description>
                                                </mat-expansion-panel-header>
                                                <tablacolaboradores></tablacolaboradores>

                                                <!--<tablaArchivos class="pt-20" [listaArchivosEmpresa]="empresa" [puedeBorrar]=false [actualizaArchivos]="eventsSubject.asObservable()"></tablaArchivos>-->

                                            </mat-expansion-panel>
                                        </ng-container>


                                    </mat-accordion>

                                </ng-container>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <!-- ------contenido------ -->
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CENTER -->

</div>